const getEmojiFromCountry = countryCode => {
  return countryCode
    .split('')
    .map(l => String.fromCodePoint(l.toLowerCase().charCodeAt() + 127365))
    .join('')
}

export default getEmojiFromCountry
